import { BareButton } from '@calendly/ui/components/bare-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const gridWrapperIsPhoneCss = "ge370r8";
const gridWrapperCss = "gkkchrx";
export const GridWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(gridWrapperCss, {
    [gridWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const actionsContainerIsPhoneCss = "acs4rql";
const actionsContainerCss = "a1mfmqaz";
export const ActionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionsContainerCss, {
    [actionsContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const clearButtonIsPhoneCss = "ceczj5v";
const clearButtonCss = "ca5ii74";
export const ClearButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(clearButtonCss, {
    [clearButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");